<template>
  <el-card>

    <h2>Languages in templates</h2>

    <h4 class="mt-4">Current language</h4>
<pre>
Language i18n:            {{language}}
Language i18n (template): {{$i18n.locale}}
Language RTDB:            {{user_get_language}}
Loaded Languages:         {{loadedLanguages}} (not reactive)
</pre>

    <h4 class="mt-4">i18n Output Examples</h4>

    <p>{{ $t("message.hello") }}</p>

    <p v-t="'message.hello'"></p>

    <p>{{ $t('message.hello2', ['hello']) }}</p>

    <p>{{ $t('message.hello3', { msg: 'hello' } ) }}</p>

    <h4 class="mt-4">i18n Pluralization</h4>

    <p>{{ $tc('car', 1) }}</p>
    <p>{{ $tc('car', 2) }}</p>
    <p>{{ $tc('apple', 0) }}</p>
    <p>{{ $tc('apple', 1) }}</p>
    <p>{{ $tc('apple', 10, { count: 10 }) }}</p>

    <h4 class="mt-4">Number localization</h4>

    <p>{{ $n(100, 'currency', 'en-US') }}</p>

    <h2>Languages in libraries</h2>
    <div :key="componentKey">
      componentKey: {{componentKey}}

      <h4 class="mt-4">Element UI</h4>

      <el-date-picker :key="componentKey+'A'" v-model="value1" type="date" placeholder="Pick a day" />
      <el-cascader :key="componentKey+'B'" :options="[]" v-model="value1"></el-cascader>

      <h4 class="mt-4">Moment JS</h4>

      {{moment_locale_test}}
      <el-button @click="onRefresh">refresh</el-button>
    </div>

    <el-card class="mt-8">
      <h2>Testing</h2>

      <el-button @click="loadLanguage('ja')">Load Language JA</el-button><br>
      <el-button @click="loadLanguage('de')">Load Language DE</el-button><br>
      <!-- TODO: currently loaded langs -->

      <h4 class="mt-4">Set user language</h4>
      <el-select
        v-model="selectedLanguage"
        filterable
        reserve-keyword>
        <el-option
          v-for="item in languageList"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <el-button @click="writeLanguageToDB">Write Timezone to DB</el-button>
    </el-card>
  </el-card>
</template>

<script>
import moment from '@/moment-gp.js'
import { loadLanguageAsync, getLoadedLanguages } from '@/i18n'

export default {
  data: () => ({
    componentKey: 1,
    selectedLanguage: 'EN',
    loadedLanguages: [],
    value1: null
  }),
  computed: {
    user_get_language() {
      return this.$models.userSettings.getters.user_get_language
    },

    timezone_guess() {
      return moment.tz.guess();
    },

    language() {
      return this.$i18n.locale;
    },

    languageList() {
      return ['en', 'EN', 'JA', 'DE', 'CN'].map(lang => ({ value: lang, label: lang }));
    },

    moment_locale_test() {
      console.log("UPDATE", this.componentKey);
      return moment().format('LLLL');
    }
  },
  methods: {
    loadLanguage(lang) {
      console.log("loading " + lang + "...");
      loadLanguageAsync(lang).then((lang) => {
        console.log("...loaded: " + lang);
        this.loadedLanguages = getLoadedLanguages();
      })
    },

    writeLanguageToDB() {
      let updatedUserData = {
        'settings/language': this.selectedLanguage,
      }
      this.$api.user_update_settings(updatedUserData).then(() => {
        console.log("Language sucessfully written");
      }).catch(() => {
        console.log("Language not written");
      });
    },

    onRefresh() {
      this.componentKey += 1;
      // this.$forceUpdate();
    }
  },
  components: {
  }
}
</script>
